import { TEXT_ANIMATION_DURATION } from '@/assets/js/highlight/config'

const textAnimation = lines => (
  new TimelineMax()
    .staggerTo(lines, TEXT_ANIMATION_DURATION, { x: '100%' }, 0.15)
)

export default textAnimation



// WEBPACK FOOTER //
// ./src/assets/js/highlight/text.js